import classNames from 'classnames';
import { type PropsWithChildren } from 'react';

import ProgressIndicator from '@/components/ProgressIndicator';

import s from './Label.module.scss';

export type LabelProps = {
  label: string;
  compact?: boolean;
  hideLabel?: boolean;
  description?: string;
  hint?: string;
  errorMessage?: string;
  /** When true, shows the label in the error colour without rendering error text below. */
  hasError?: boolean;
  required?: boolean;
  id?: string;
  className?: string;
  isFetching?: boolean;
};

const Label: React.FC<PropsWithChildren<LabelProps>> = ({
  label,
  compact,
  hideLabel,
  description,
  hint,
  errorMessage,
  hasError,
  required,
  children,
  id,
  className,
  isFetching,
}) => {
  const Tag = hideLabel ? 'div' : 'label';
  return (
    <Tag className={classNames(compact ? s.compactContainer : s.container, className)} id={id}>
      {!hideLabel && (label || description) && (
        <>
          <div className={s.top}>
            {label && (
              <p
                className={classNames(
                  compact ? s.compactLabel : 'body-sm-bold',
                  (hasError || !!errorMessage) && 'text-[var(--color-error)]',
                )}
              >
                {label}
                {required && <span className={compact ? s.compactRequired : 'body-sm'}>*</span>}
              </p>
            )}
            {description && (
              <p className='caption'>
                <span className={s.description}>{description}</span>
                {required && !label && <span className={compact ? s.compactRequired : 'caption'}>&nbsp;&nbsp;*</span>}
              </p>
            )}
            {isFetching && <ProgressIndicator size={16} />}
          </div>
        </>
      )}
      {children}
      {(errorMessage || hint) && <p className={errorMessage ? s.error : s.hint}>{errorMessage || hint}</p>}
    </Tag>
  );
};

export default Label;
